(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCompanyListController', AgentCompanyListController);

    AgentCompanyListController.$inject = ['$timeout', '$scope', '$stateParams', 'CompanyCustom'];

    function AgentCompanyListController($timeout, $scope, $stateParams, CompanyCustom) {
        var vm = this;
        vm.companies = [];

        loadData();

        function loadData() {
            vm.companies = CompanyCustom.findCompaniesForAgentRequest().query();
        }


    }
})();
